module.exports = __webpack_public_path__ + "img/white.e55491c8.svg";